/**
 * Removes any null, undefined, or empty string
 * values in obj
 *
 * @param {object} obh
 * @returns {object}
 */
const cleanData = obj => {
  for (let propName in obj) {
    if (
      obj[propName] === null ||
      obj[propName] === undefined ||
      obj[propName] === ''
    ) {
      delete obj[propName];
    }
  }
  return obj;
};

export default cleanData;
